"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require("./util");

var list = [{
  "freq": 10.8,
  "color": "rgb(0, 125, 197)"
}, {
  "freq": 33,
  "color": "rgb(0, 144, 76)"
}, {
  "freq": 33.8,
  "color": "rgb(0, 172, 204)"
}, {
  "freq": 55,
  "color": "rgb(0, 145, 132)"
}, {
  "freq": 62.64,
  "color": "rgb(165, 85, 117)"
}, {
  "freq": 63,
  "color": "rgb(205, 157, 125)"
}, {
  "freq": 70,
  "color": "rgb(242, 135, 183)"
}, {
  "freq": 73.6,
  "color": "rgb(0, 102, 154)"
}, {
  "freq": 83,
  "color": "rgb(126, 136, 63)"
}, {
  "freq": 98.4,
  "color": "rgb(164, 84, 138)"
}, {
  "freq": 105,
  "color": "rgb(208, 156, 80)"
}, {
  "freq": 110,
  "color": "rgb(205, 232, 212)"
}, {
  "freq": 111,
  "color": "rgb(109, 166, 159)"
}, {
  "freq": 147,
  "color": "rgb(199, 234, 251)"
}, {
  "freq": 147.85,
  "color": "rgb(13, 177, 75)"
}, {
  "freq": 172.06,
  "color": "rgb(0, 158, 218)"
}, {
  "freq": 210.42,
  "color": "rgb(0, 157, 188)"
}, {
  "freq": 221.23,
  "color": "rgb(248, 169, 143)"
}, {
  "freq": 264,
  "color": "rgb(150, 213, 210)"
}, {
  "freq": 293,
  "color": "rgb(127, 82, 139)"
}, {
  "freq": 342,
  "color": "rgb(3, 78, 162)"
}, {
  "freq": 396,
  "color": "rgb(87, 196, 206)"
}, {
  "freq": 404,
  "color": "rgb(85, 80, 139)"
}, {
  "freq": 408,
  "color": "rgb(20, 78, 140)"
}, {
  "freq": 410,
  "color": "rgb(52, 131, 170)"
}, {
  "freq": 413,
  "color": "rgb(92, 45, 145)"
}, {
  "freq": 416,
  "color": "rgb(199, 26, 121)"
}, {
  "freq": 417,
  "color": "rgb(204, 123, 104)"
}, {
  "freq": 420.82,
  "color": "rgb(0, 185, 240)"
}, {
  "freq": 440,
  "color": "rgb(245, 130, 32)"
}, {
  "freq": 448,
  "color": "rgb(249, 213, 229)"
}, {
  "freq": 528,
  "color": "rgb(249, 166, 27)"
}, {
  "freq": 630,
  "color": "rgb(96, 52, 56)"
}, {
  "freq": 639,
  "color": "rgb(202, 125, 154)"
}, {
  "freq": 685,
  "color": "rgb(201, 88, 115)"
}, {
  "freq": 852,
  "color": "rgb(117, 112, 178)"
}, {
  "freq": 880,
  "color": "rgb(103, 193, 140)"
}, {
  "freq": 1052,
  "color": "rgb(156, 149, 201)"
}, {
  "freq": 12000,
  "color": "rgb(165, 40, 104)"
}];
function color(n) {
  n = (0, _util.mod)(n, list.length);
  return list[n].color;
}
function index(n) {
  n = (0, _util.mod)(n, list.length);
  return list[n].freq;
}

exports.default = { index: index, color: color, list: list };


//////////////////
// WEBPACK FOOTER
// ./client/lib/colundi.js
// module id = 5
// module chunks = 0